import { QRCode } from 'react-qrcode-logo';
import React, { useState, useEffect } from "react";
import { useParams } from 'react-router';
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/////



//
import moment from "jalali-moment";
import { DeleteMethod } from '../../helper/Api';




//
import LogOut from "../../redux/featuer/user/userSlice";
import Layout from "../../component/Layout/Layout";
import Card from "../../component/Layout/theme/card";
import PageChange from '../../component/pageChange';
import Modal from '../../component/Layout/theme/modal';
import toast from 'react-hot-toast';



function QrCodeComponent() {

    const { id } = useParams();



    const { token, user } = useSelector((item) => item.user);
    const [userName, SetUserName] = useState('');
    const [url, SetUrl] = useState('');
    const [name, setName] = useState('');
    const [date, setDate] = useState(Date.now());
    const [view, setView] = useState('');
    const [typeNft, setTypeNft] = useState()
    const [isDataLoad, setIsDataLoad] = useState(false)
    const [statusPayment, setStatusPayment] = useState()


    const [showQrModal, setShowQrMoadal] = useState(false)

    const [disableButton, setDisableButton] = useState(false)


    var qrSize = 1350;
    var { t } = useTranslation();

    ////getQuery
    const params = useParams();

    const downloadQRCode = (name) => {
        const canvas = document.getElementById("QR");
        if (canvas) {
            const pngUrl = canvas
                .toDataURL("image/png")
                .replace("image/png", "image/octet-stream");
            let downloadLink = document.createElement("a");
            downloadLink.href = pngUrl;
            downloadLink.download = `${name}.png`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    };

    useEffect(() => {
        getPayment();
    }, [getPayment]);

    async function getPayment() {
        try {
            const res = await fetch(`${process.env.REACT_APP_SERVER}/api/payment/onePay/${params.id}`, {
                method: "GET",
                headers: {
                    Authorization: "ArNew " + token,
                },
            });
            const result = await res.json();


            if (result.status === "error") {
                window.location.href = '/';

            }
            if (!result.data) {
                LogOut();
                toast.error(t("you_not_access"));
                window.location.href = 'login';
            }

            if (result.status === "success") {
                SetUserName(result.data.user.username);
                SetUrl(result.data.url)
                setName(result.data.name)
                setDate(result.data.create_in)
                setView(result.data.view)
                setTypeNft(result.data.types)
                setStatusPayment(result.data.statusPayment)
                setIsDataLoad(true)

            } else {
                toast.error(result.msg);
                LogOut();
                window.location.href = 'login';
            }
        } catch (error) {
            // handle error
        }
    }

    const copyText = () => {
        window.navigator.clipboard.writeText(`${process.env.REACT_APP_CLIENT}/view/${userName}/${url}`)
        toast.error(t("link_was_copied"))
    }

    const newTabUrl = () => {
        window.open(`${process.env.REACT_APP_CLIENT}/view/${userName}/${url}`, '_blank')
    }


    const submitForm = async () => {

        setDisableButton(true)

        var url = `/api/nft/edit/${id}`;

        await DeleteMethod(
            { url: url, token: token },
            (res) => {
                if (res.status === "success") {
                    toast.error(t("mission_was_successful"))
                    window.history.back();
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                    setDisableButton(false)
                }
            },
            (error) => {
                toast.error(error);
                setDisableButton(false)
            }
        );


    };

    return (
        <>
            {
                isDataLoad ? (
                    <>
                        <Layout />
                        <Card>
                            <div className='bg-white p-5 shadow-md rounded-lg mb-24 '>
                                <div className="flex flex-col items-center justify-center mb-5 space-y-3">
                                    <p className="font-medium text-gray-800 text-sm">ARLive</p>
                                    <p className="text-lg font-bold text-gray-800">
                                        {t("your_qr_code")}
                                    </p>
                                    <p className="text-center font-medium text-sm text-gray-800 w-60 md:w-full">
                                        {t("scan_qr_code")}
                                    </p>

                                </div>
                                <div className="flex flex-col items-center justify-center gap-5 " >
                                    <div className="canvas-qr">
                                        <QRCode
                                            value={`${process.env.REACT_APP_CLIENT}/view/${userName}/${url}`}
                                            size={qrSize}
                                            logoImage={typeNft !== 0 ? "/public/logo.png" : user.logo ? `${process.env.REACT_APP_SERVER}${user.logo}` : "/public/logo.png"}
                                            fgColor={"#000"}
                                            removeQrCodeBehindLogo={false}
                                            quietZone={5}
                                            enableCORS={true}
                                            eyeRadius={[
                                                { // top/left eye
                                                    outer: [10, 10, 0, 10],
                                                    inner: [0, 10, 10, 10],
                                                },
                                                [10, 10, 10, 0], // top/right eye
                                                [10, 0, 10, 10], // bottom/left
                                            ]}
                                            logoWidth={qrSize / 2}
                                            logoHeight={qrSize / 2}
                                            logoOpacity={0.4}
                                            ecLevel={'Q'}
                                            qrStyle={"dots"} // squares
                                            id={"QR"}
                                        />
                                    </div>
                                    <div className="flex items-center text-gray-800 font-medium text-sm justify-center w-full gap-10 " id='wrapper'>
                                        <div className="flex flex-col gap-3" id='wrapper'>
                                            <p>{t("names")}:</p>
                                            <p>{t("dates")}:</p>
                                            <p> {t("visit")}:</p>
                                        </div>
                                        <div className="flex flex-col gap-3 " id='wrapper'>
                                            <span>{name}</span>
                                            <span>   {moment(new Date(parseInt(date))).format(
                                                "jYYYY/jMM/jDD"
                                            )}</span>
                                            <span>{view}</span>
                                        </div>
                                    </div>

                                    <button className="font-medium text-sm text-gray-800 cursor-pointer" value={`${process.env.REACT_APP_CLIENT}/view/${userName}/${url}`} onClick={newTabUrl}>
                                        {`${process.env.REACT_APP_CLIENT}/view/${userName}/${url}`}
                                    </button>

                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 px-5 gap-5 mt-10">
                                    <div>
                                        <button onClick={copyText} className="px-4 w-full py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300" >
                                            {t("copy")}
                                        </button>
                                    </div>
                                    <div>
                                        <button onClick={() => downloadQRCode(name)} value="Download" className="px-4 w-full py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300">
                                            {t("download_qr_code")}
                                        </button>
                                    </div>
                                    <div>

                                        <Link to={`/qrcode/edit/${id}`}>
                                            <button value="Download" className="px-4 w-full py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300">
                                                {t("edit")}
                                            </button>
                                        </Link>
                                    </div>
                                    <div>
                                        <button className="px-4 w-full py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300" onClick={() => setShowQrMoadal(true)}>
                                            {statusPayment ? t("cancel_augmented_reality") : t("Delete_augmented_reality")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Card>
                        <Modal isVisible={showQrModal} onClose={() => setShowQrMoadal(false)} >
                            <div className="px-6 py-6 lg:px-8">
                                <p className="flex justify-center text-xl font-medium text-gray-900 " >
                                    {
                                        statusPayment
                                            ?
                                            t("cancel_augmented_reality")
                                            :
                                            t("Delete_augmented_reality")
                                    }
                                </p>
                                <h3 className="flex justify-center mt-5 mb-4 font-medium text-gray-900 dark:text-white">
                                    {
                                        statusPayment
                                            ?
                                            t("Are_you_sure_about_canceling_augmented_reality")
                                            :
                                            t("Are_you_sure_about_removing_augmented_reality")
                                    }
                                </h3>
                                <div className='flex justify-center gap-3'>
                                    <button className="w-full mt-5 text-white bg-teal-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" disabled={disableButton ? true : false} onClick={() => submitForm()}>{t("yes")}</button>
                                    <button className="w-full mt-5 text-white bg-red-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" onClick={() => setShowQrMoadal(false)}>{t("no")}</button>

                                </div>
                            </div>
                        </Modal>

                    </>

                ) : <PageChange />}

        </>
    );
}

export default QrCodeComponent;
